import React from 'react'

export var TabPreferences = {
        rowsPerPage:0,
        orderingColumn:'',
        orderingOrder:''
}